<template>
  <div>
    <div v-if="md" class="wrapper-chatbox">
      <!-- Button -->
      <div @click="toggle = !toggle" class="chatIcon" v-if="!toggle">
        <inline-svg
          :style="cssVar"
          class="chaticon"
          :src="publicUrl(`img/chaticon.svg`)"
          width="50"
          style="cursor: pointer"
        />
      </div>

      <div v-if="md" v-show="toggle" class="modal-chatbox">
        <div class="btn-minimize">
          <v-btn
            icon
            small
            :color="$store.getters.setting.minimizeBtnColor"
            plain
            :ripple="false"
            @click="onClose"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>

          <template v-if="setting.hasLogin && $store.state.isLogin">
            <v-btn
              icon
              small
              :color="$store.getters.setting.minimizeBtnColor"
              plain
              :ripple="false"
              @click="onLogout"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </div>

        <component :is="view"></component>
      </div>
    </div>

    <div v-if="!md" class="wrapper-chatbox-mobile">
      <!-- Button -->
      <div @click="toggle = !toggle" class="chatIcon-mobile" v-if="!toggle">
        <inline-svg
          :style="cssVar"
          class="chaticon"
          :src="publicUrl(`img/chaticon.svg`)"
          width="50"
          style="cursor: pointer"
        />
      </div>

      <!-- Mobile -->
      <div v-if="!md" v-show="toggle" class="modal-chatbox-mobile">
        <div class="btn-minimize">
          <v-btn
            icon
            small
            :color="$store.getters.setting.minimizeBtnColor"
            plain
            :ripple="false"
            @click="onClose"
          >
            <v-icon>mdi-minus</v-icon>
          </v-btn>

          <template v-if="setting.hasLogin && $store.state.isLogin">
            <v-btn
              icon
              small
              :color="$store.getters.setting.minimizeBtnColor"
              plain
              :ripple="false"
              @click="onLogout"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </div>

        <component :is="view"></component>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from './Chat.vue'
import Login from './Login/index.vue'
import Regis from './Regis/index.vue'
import InlineSvg from 'vue-inline-svg'
import { mapGetters } from 'vuex'
export default {
  components: {
    Chat,
    Login,
    Regis,
    InlineSvg
  },
  data() {
    return {
      toggle: false,
      minimize: false,
      chatIconColor: '#eeeeee'
    }
  },
  mounted() {
    var id = localStorage.getItem('id')
    this.chatIconColor = this.$store.getters.setting.chatIconColor || '#eeeeee'

    if (id) {
      this.toggle = true
    }
  },
  computed: {
    ...mapGetters(['setting']),
    cssVar() {
      return {
        '--chat-icon-color': this.chatIconColor
      }
    },
    page() {
      return this.$store.getters.page
    },
    view() {
      if (this.setting.hasLogin) {
        if (this.$store.state.isLogin) return 'chat'
        else if (this.page) return this.page
        else return 'login'
      } else {
        return 'chat'
      }
    },
    md() {
      return (
        this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
      )
    },
    loginStatus() {
      return this.$store.state.isLogin
    }
  },
  methods: {
    onClose() {
      this.toggle = false
    },
    onLogout() {
      localStorage.removeItem('id')
      localStorage.removeItem('chatlog')
      this.$store.state.isLogin = false
      this.toggle = false
    }
  }
}
</script>

<style lang="scss">
.wrapper-login-box {
  width: 100%;
  max-height: 458px;
  padding: 0 32px 20px;
  overflow: auto;
  text-align: left;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #ffffff;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #cccccc;
    border-radius: 0px;
    border: 3px none #ffffff;
  }
}

.chaticon .cls-2 {
  fill: var(--chat-icon-color);
}
.wrapper-chatbox {
  position: fixed;
  bottom: 30px;
  right: 0px;
  z-index: 9999;
}
.chatIcon {
  position: absolute;
  bottom: 20px;
  right: 10px;
  cursor: pointer;
}
.modal-chatbox {
  position: relative;
  height: 500px;
  min-width: 400px;
  max-width: 400px;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0 0 0 / 0.2);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin-right: 10px;
  margin-bottom: 30px;
  background-color: #fff;
}

.modal-chatbox-mobile {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  // height: 400px;
  width: 100%;
  overflow: hidden;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgba(0 0 0 / 0.2);
  background-color: #fff;
  z-index: 9999;
}
.chatIcon-mobile {
  position: fixed;
  bottom: 50px;
  right: 10px;
  cursor: pointer;
  z-index: 1;
}
.btn-minimize {
  position: absolute;
  top: 0;
  z-index: 1;
  right: 5px;
  top: 3px;
}

@media only screen and (max-width: 756px) {
  .chatIcon-mobile {
    position: fixed;
    bottom: 60px;
    right: 60px;
    cursor: pointer;
    z-index: 1;
  }
}
</style>
